import { buttonVariants } from '@repo/shared-client/components/ui'
import { cn } from '@repo/shared-client/lib/utils'
import { createFileRoute } from '@tanstack/react-router'
import LogoSymbol from '@web/src/components/primatives/logo-symbol/logo-symbol'
import { useTranslation } from '@web/src/lib/intl/react'
import { MailIcon, MapPinHouseIcon } from 'lucide-react'
import { contactPageHeadFromLoaderData } from './contact.seo'

const mailLinkClass = cn(buttonVariants({ variant: 'link' }), 'break-all text-base')

export const Route = createFileRoute('/(public)/(main-layout)/contact')({
  component: ContactPage,
  head: ({ loaderData }) => contactPageHeadFromLoaderData(loaderData),
})

function ContactPage() {
  const { t } = useTranslation()

  return (
    <div className="mx-auto max-w-5xl px-4 py-10 pb-16">
      <div className="flex flex-col items-center justify-center gap-4 py-10 sm:flex-row">
        <LogoSymbol imageClassName="w-20" />
        <h1 className="text-center font-bold text-4xl text-foreground tracking-tight">{t('GET IN TOUCH')}</h1>
      </div>

      <div className="grid w-full grid-cols-1 gap-10 md:grid-cols-2">
        <section className="flex h-full flex-col items-center gap-4">
          <div
            aria-hidden
            className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full bg-muted text-foreground"
          >
            <MailIcon className="size-8" />
          </div>
          <h2 className="font-semibold text-3xl text-foreground">{t('Email')}</h2>

          <div className="flex flex-col items-center gap-1">
            <p className="text-center text-foreground text-lg">{t('Support')}</p>
            <a className={mailLinkClass} href="mailto:support@spicyfriends.com">
              support@spicyfriends.com
            </a>
          </div>

          <div className="flex flex-col items-center gap-1">
            <p className="text-center text-foreground text-lg">{t('Legal and privacy')}</p>
            <a className={mailLinkClass} href="mailto:legal@spicyfriends.com">
              legal@spicyfriends.com
            </a>
          </div>

          <div className="flex flex-col items-center gap-1">
            <p className="text-center text-foreground text-lg">{t('Copyright Complaints')}</p>
            <a className={mailLinkClass} href="mailto:dmca@spicyfriends.com">
              dmca@spicyfriends.com
            </a>
          </div>

          <div className="flex flex-col items-center gap-1">
            <p className="text-center text-foreground text-lg">{t('Safety reports')}</p>
            <a className={mailLinkClass} href="mailto:safety@spicyfriends.com">
              safety@spicyfriends.com
            </a>
          </div>
        </section>

        <section className="flex h-full flex-col items-center gap-4">
          <div
            aria-hidden
            className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full bg-muted text-foreground"
          >
            <MapPinHouseIcon className="size-8" />
          </div>
          <h2 className="font-semibold text-3xl text-foreground">{t('Address')}</h2>

          <div className="flex flex-col items-center gap-1">
            <p className="text-center text-foreground text-sm">{t('7242 Wellington Rd 124')}</p>
            <p className="text-center text-foreground text-sm">{t('Guelph, Ontario, Canada, N1H 6J3')}</p>
          </div>
        </section>
      </div>
    </div>
  )
}
